"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FormalReview_1 = require("utils/FormalReview");
const HelperUtils_1 = require("utils/HelperUtils");
require("./sidebar-left-menu-navigator");
function SidebarLeftMenuNavigator({ listMenu = [{ id: 'progress', title: 'Progress', onClick: () => null }], title = '', activeMenu = 'progress', customClass = '', onClickMenu, children, isUsingGeneralFunction, minHeightSidebar = 'min-h-[calc(100vh-64px)]' }) {
    return (react_1.default.createElement("div", { className: `sidebar-left-navigator ${minHeightSidebar} ${customClass}` },
        title && (react_1.default.createElement("div", { className: "sidebar-left-navigator-header" },
            react_1.default.createElement("p", { className: "typography-h200 typography-secondary uppercase" }, title))),
        listMenu.map((menu, index) => {
            const isActive = (isUsingGeneralFunction ? menu.name : menu.id) == activeMenu;
            return (react_1.default.createElement("div", { className: `sidebar-left-navigator-menu px-[24px] py-[12px] ${isActive ? 'active' : ''}`, key: index, "data-cy": isUsingGeneralFunction ? menu.name : menu.title, onClick: () => isUsingGeneralFunction
                    ? onClickMenu && (menu === null || menu === void 0 ? void 0 : menu.name) && onClickMenu(menu.name)
                    : menu.onClick() },
                react_1.default.createElement("p", { className: `typography-button ${isActive ? 'text-base-600' : 'text-n-600'}` }, isUsingGeneralFunction
                    ? (0, HelperUtils_1.getObjectiveLocale)((0, FormalReview_1.phaseName)(menu.name))
                    : menu.title)));
        }),
        children && (react_1.default.createElement("div", { className: "mt-[24px] border-bottom-400 border-top-400 py-[24px] px-[24px]" }, children))));
}
exports.default = SidebarLeftMenuNavigator;
